import { createSlice } from "@reduxjs/toolkit"
import { TransactionRows } from "../api/Transaction"

interface IState {
  inTransaction: boolean
  transactions: TransactionRows
}

const transactionSlice = createSlice({
  name: "transaction",

  initialState: {
    inTransaction: false,
    transactions: []
  },

  reducers: {
    beginTransaction: (state: IState, action) => {
      state.inTransaction = true
    },

    endTransaction: (state: IState, action) => {
      state["inTransaction"] = false
    },

    saveTransaction: (state: IState, action) => {
      state.transactions = action.payload
    }
  }
})

export const {
  beginTransaction,
  endTransaction,
  saveTransaction
} = transactionSlice.actions

export default transactionSlice.reducer
